import React, { memo } from "react";

import { PageTemplate } from "../../components/templates";
import { Container, Grid, Card, Stack } from "investira.react.components";
import RecursoGarantidorProvider from "../../contexts/RecursoGarantidorContext";
import Carteira from "./Carteira";

const CarteiraAdd = memo(() => {
  return (
    <RecursoGarantidorProvider tipo="carteira">
      <Container sx={{ height: "100%" }} maxWidth="md">
        <PageTemplate title="Nova Carteira" subtitle="Simulação">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <Stack spacing={2} sx={{ pt: 3, pb: 1, px: 2 }}>
                  <Carteira />
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </PageTemplate>
      </Container>
    </RecursoGarantidorProvider>
  );
});

CarteiraAdd.displayName = "CarteiraAdd";

export default CarteiraAdd;
